import React, { Component, Fragment } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { Grid, Typography, Button } from '@mui/material';
import MOBILE_SIDEPANEL_CLASSES from './mobileSidePanelClasses';
import { updateMobileOfferForm } from '../../../actions/mobileActions';
import TimeOffRequestCreationStep from '../../Utils/TimeOffRequestCreationStep';
import { TorCreationType } from '../../../../Enums';


class TimeOffRequestCreation extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleTimeOffRequestSubtypeIdSelected = (val) => {
        const { formData, updateMobileOfferForm } = this.props
        updateMobileOfferForm({
            ...formData,
            timeOffRequestSubtypeIdSelected: val
        });
    }

    handleTimeOffRequestReasonIdSelected = (val) => {
        const { formData, updateMobileOfferForm } = this.props

        updateMobileOfferForm({
            ...formData,
            timeOffRequestReasonIdSelected: val
        });
    }

    render() {
        const { formData, classes, updateSidePanelView, handlePreviousView, timeOffRequestSubtypes, t } = this.props;
        const { timeOffRequestReasonIdSelected, timeOffRequestSubtypeIdSelected, managerSetting } = formData;
        const isTimeOffRequestSubtypeInvalid = () => {
            if (!!managerSetting && managerSetting.timeOffRequestCreationType === TorCreationType.None) {
                return false;
            }

            if (timeOffRequestSubtypeIdSelected) {
                if (!timeOffRequestReasonIdSelected) {
                    return true;
                }
                const selectedSubtype = timeOffRequestSubtypes.find(x => x.id === timeOffRequestSubtypeIdSelected);
                const isInvalidReasonId = selectedSubtype && !selectedSubtype.reasons.some(x => x.id === timeOffRequestReasonIdSelected);
                return isInvalidReasonId;
            }
            return false;
        }

        return (
            <Fragment>
                <div className={classes.viewContainer}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant={'h5'} className={classes.viewHeader}> {
                            managerSetting.timeOffRequestCreationType == TorCreationType.Optional ? 
                                        t('employeeSidePanel.torCreationStep.titleOptional') : 
                                        t('employeeSidePanel.torCreationStep.title')} </Typography>
                        </Grid>
                        <TimeOffRequestCreationStep
                            updateStateSubtypeId={this.handleTimeOffRequestSubtypeIdSelected}
                            updateStateReasonId={this.handleTimeOffRequestReasonIdSelected}
                            handleTimeOffRequestSelected={this.handleTimeOffRequestSelected}
                            timeOffRequestSubtypeIdSelected={timeOffRequestSubtypeIdSelected}
                            timeOffRequestReasonIdSelected={timeOffRequestReasonIdSelected}
                            options={managerSetting.timeOffRequestCreationType == TorCreationType.Required ?
                                timeOffRequestSubtypes.filter(option => option.id !== null) :
                                timeOffRequestSubtypes
                            }
                        />
                    </Grid>
                    <Grid container className={classes.bottomBar}>
                        <Grid item xs={6} style={{ padding: '5px' }}>
                            <Button fullWidth className={classes.secondaryButton} onClick={handlePreviousView}>
                                Back
                            </Button>
                        </Grid>
                        <Grid item xs={6} style={{ padding: '5px' }}>
                            <Button fullWidth className={classes.primaryButton} onClick={() => updateSidePanelView('Summary')} disabled={isTimeOffRequestSubtypeInvalid()}>
                                Next
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        classes: MOBILE_SIDEPANEL_CLASSES,
        formData: state.mobileOfferShiftForm,
        options: state.httpOptions,
        timeOffRequestSubtypes: state.timeOffRequestSubtypes,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateMobileOfferForm: payload => dispatch(updateMobileOfferForm(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('employmentBillboard')(TimeOffRequestCreation));